import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY devem estar definidos no .env');
}

/** Evita respostas antigas em cache (navegador/CDN) nas leituras REST do PostgREST. */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    global: {
        fetch: (url, options = {}) =>
            fetch(url, {
                ...options,
                cache: 'no-store',
            }),
    },
    realtime: {
        params: { eventsPerSecond: 30 },
    },
});
